var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.roles.includes('buyer') || _vm.roles.includes('wholesaler'))?_c('div',[_c('OrdersList')],1):(_vm.roles.includes('seller'))?_c('div',[_c('SellerOrdersList')],1):(_vm.roles.includes('caretaker'))?_c('div',[_c('CaretakerOrdersList')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }